<template>
    <div class="TeamRecord" v-if="TeamRecordData.SubProgram">
        <div class="container-fluid">
            <div class="row">
                <div class="col col-md-12">
                    <button type="button" class="close" v-on:click="CloseRecord"><span>x</span></button>
                    <h1><span>{{ TeamRecordData.Name }}</span></h1>
                    <h4><span class="bold">{{ TeamRecordData.SubProgram.Name }}</span> {{ TeamRecordData.Address.City }}</h4>
                </div>
            </div>
            <div class="row" style="margin-top: 10px;">
                <div class="col">
                    <div class="record-tabs">
                        <span class="d-none d-sm-block">
                            <b-nav>
                                <div v-for="pane in Panes">
                                    <b-nav-item v-on:click="ChangePaneShown(pane.name)" v-bind:class="{ active: PaneShown == pane.name }">{{pane.name}}</b-nav-item>
                                </div>
                            </b-nav>
                        </span>
                        <b-nav>
                            <span class="d-sm-none">
                                <b-nav-item-dropdown :text=changeDropdownName id="mobileDropdown">
                                    <div v-for="pane in Panes">
                                        <b-dropdown-item v-on:click="ChangePaneShown(pane.name)" v-bind:class="{ active: PaneShown == pane.name }">{{pane.name}}</b-dropdown-item>
                                    </div>
                                </b-nav-item-dropdown>
                            </span>
                        </b-nav>
                    </div>
                    <div class="tab-content">
                        <div v-show="PaneShown == 'Summary'">
                            <TeamSummary v-bind:team-record-data="TeamRecordData" />
                        </div>
                        <div v-show="PaneShown == 'Info'">
                            <Information v-bind:team-record-data="TeamRecordData" />
                        </div>
                        <div v-show="PaneShown == 'People'">
                            <People v-bind:team-record-data="TeamRecordData" />
                        </div>
                        <div v-show="PaneShown == 'Admin'">
                            <Admin v-bind:team-record-data="TeamRecordData" />
                        </div>
                        <div v-show="PaneShown == 'Reports'">
                            <Reports v-bind:team-record-data="TeamRecordData" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import components
    //import Admin from "./Admin.vue";
    //import Information from "./Information.vue";
    import People from "./People.vue";
    import TeamSummary from "./Summary.vue";
    import Reports from "./Reports.vue";
    import { EventBus } from '../../../../services/event-bus.js';
    export default {
        props: [
            'TeamRecordData'
        ],
        created() {
            let vm = this;
            EventBus.$on('profile-update-needed', chartID => {
                if (chartID == vm.TeamRecordData.Id) {
                    vm.UpdateChartData();
                }
            });

        },
        beforeDestroy() {
            EventBus.$off('profile-update-needed');
        },
        data: function () {
            return {
                PaneShown: "Summary",
                Panes: [
                    { name: 'Summary' },
                    //{ name: 'Team Info' },
                    { name: 'People' },
                    { name: 'Reports' }
                    //{ name: 'Admin' }
                ]
            };
        },
        methods: {
            UpdateChartData() {
                this.$MasterAPI.ExecuteRequest("GET", "Wraparound/Teams/GetTeam", { Id: this.TeamRecordData.Id }, this.UpdateChartDataSuccess, () => { }, true);
            },
            UpdateChartDataSuccess(response) {
                this.$store.commit("Teams.TeamEnrollmentList.ReplaceSingleRecord", response.data.data);
            },
            ChangePaneShown(paneName) {
                this.PaneShown = paneName;
            },
            formatDate (value, fmt = 'MM/DD/YY', defaultText = '') {
              return (value == null)
                ? defaultText
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CloseRecord() {
                this.$parent.CloseRecord("Teams.TeamProfiles.Remove","TeamList",this.TeamRecordData.Id);
            },
        },
        components: {
            //Admin,
            //Information,
            People,
            TeamSummary,
            Reports
        },
        mounted() { 
        },
        computed: {
            changeDropdownName: function () {
                return this.PaneShown;
            },
        },
    }
</script>

<style scoped>
    .record-tabs {
        width: 100%;
        display: inline-block;
    }
    @media only screen and (max-width: 576px) {
        h4{
        font-size: 1em;
        }
        h1{
        font-size: 1.5em;
        }
    }
    li a{
        color:black !important;
    }
    li.active a {
        color: black !important;
    }
</style>